<template>
  <main class="font page-main">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('fonts.head') }}</h3>
      <div class="package-download">
        <p class="m">{{ $t('fonts.license.m') }}</p>
        <a
          ref="allDownload"
          :href="require('@/static/font/BM-fonts-package.zip')"
          download
          class="btn btn-fill pc"
          @click="ga({
            action: '글꼴 전체 패키지 다운로드',
            category: '폰트'
          })"
        >
          {{ $t('fonts.downloadAll') }}
        </a>
      </div>
    </section>

    <!--<section class="font-visual" data-style="show">
      <video
        muted
        loop
        autoplay
        playsinline
        poster="~@/static/image/font/pc/visual.jpg"
      >
        <source src="~@/static/video/fonts_visual.mp4" type="video/mp4">
        Sorry, your browser doesn't support embedded videos.
      </video>
      <div class="font-visual-inner">
        <h3>{{ $t('menuFonts') }}</h3>
        <div class="font-visual-description">
          <html-view :value="$t('fonts.description')" />
        </div>
        <p>
          <a
            ref="allDownload"
            :href="require('@/static/font/BM-fonts-package.zip')"
            download
            class="btn font-download"
            @click="ga({
              action: '글꼴 전체 패키지 다운로드',
              category: '폰트'
            })"
          >{{ $t('fonts.downloadAll') }}</a>
        </p>
      </div>
    </section>-->

    <section class="font-preview" data-style="default">
      <div class="font-preview-title">{{ selectFont.shortName }}</div>
      <div class="font-preview-value" :class="{'dohyeon': selectFont.family === 'BM DoHyeon'}" :style="`font-family: '${selectFont.family}', sans-serif`">
        <div class="value" contenteditable @input="onPreviewText" />
        <div v-if="previewText.length <= 0" class="placeholder">{{ $t('fonts.placeholder') }}</div>
      </div>
      <div class="font-preview-list">
        <template v-for="(item, key) in list.filter(v => v.shortName)">
          <button
            v-if="item.shortName && item.family"
            :key="key"
            :disabled="!item.family"
            type="button"
            class="btn"
            :class="{
              'btn-fill': selectFontIndex === key
            }"
            :data-text="item.shortName"
            @click="selectFontIndex = key"
          >
            {{ item.shortName }}
          </button>
        </template>
      </div>
    </section>

    <!--<section class="font-mobile" data-style="default">
      <html-view :value="$t('fonts.mobileCannot')" tag="h4" />
      <html-view :value="$t('fonts.description')" class="font-mobile-description" />
      <share
        :list="['kakaotalk', 'facebook', 'twitter', 'link']"
        :share-image="shareImagePath"
        :title="$route.params.locale === 'en' ? 'Baedal Minjok Fonts' : '배달의민족 글꼴'"
        @click:share="onClickShare"
      />
      &lt;!&ndash;      <share :list="['kakaotalk', 'facebook', 'twitter', 'link']" url="" :title="" />&ndash;&gt;
    </section>-->

    <section class="font-list" data-style="default">
      <div
        v-for="(item, key) in fontList"
        :key="key"
        class="font-box animation up"
        :class="item.className"
      >
        <images :v="item.images" />
        <p class="font-title">
          <html-view :value="$t(item.name)" tag="span" />
          <sup>{{ item.date }}</sup>
        </p>
        <html-view :value="item.description " tag="p" class="font-description" />
        <nav class="btn-wrap">
          <a
            v-for="(down, value) in item.download"
            :key="value"
            ref="fonts"
            class="btn-download"
            :href="down"
            :data-ga="`${item.nameKr} ${value.toUpperCase()} 다운로드`"
            @click="ga({
              action: `${item.nameKr} ${value.toUpperCase()} 다운로드`,
              category: '폰트'
            })"
          >
            {{ value.toUpperCase() }} {{ $t('download') }}
            <icon-download class="icon icon-download" />
          </a>
          <a
            v-if="item.link"
            :href="item.link.url"
            target="_blank"
            class="btn-link"
          >{{ item.link.text }}</a>
        </nav>
      </div>

      <!--<div class="font-next">
        <div class="font-next-description">
          <html-view :value="$t('fonts.nextFont')" tag="p" />
        </div>
        <share
          :list="['kakaotalk', 'facebook', 'twitter', 'link']"
          :share-image="shareImagePath"
          :title="$route.params.locale === 'en' ? 'Baedal Minjok Fonts' : '배달의민족 글꼴'"
          @click:share="onClickShare"
        />
      </div>-->
    </section>

    <section class="font-license" data-style="default">
      <p class="pc">{{ $t('fonts.license.pc') }}</p>
      <!--<p class="m">{{ $t('fonts.license.m') }}</p>-->
      <!--      <button type="button" @click="onToggleLicense">-->
      <!--        <span>라이센스 보러가기</span>-->
      <!--        <icon-blank />-->
      <!--      </button>-->
      <router-link :to="{name: 'FontsLicense', params: {locale: $route.params.locale}}" class="btn-link">
        <span>{{ $t('fonts.license.link') }}</span>
        <icon-blank />
      </router-link>
    </section>

    <!--    <transition v-if="isLicense" name="popup">-->
    <!--      <license>-->
    <!--        <template #close>-->
    <!--          <button type="button" class="popup-close" @click="onToggleLicense"><icon-close /></button>-->
    <!--        </template>-->
    <!--      </license>-->
    <!--    </transition>-->
  </main>
</template>

<script>
import { cloneDeep } from 'lodash'
import observer from '@/mixins/observer'
import animation from '@/mixins/animation'
import gtag from '@/mixins/gtag'

export default {
  components: {
    iconBlank: () => import('@/static/svg/blank.svg'),
    iconDownload: () => import('@/static/svg/download.svg'),
    images: () => import('@/views/fonts/Images'),
    share: () => import('@/components/base/Share'),
    // iconClose: () => import('@/static/svg/close.svg'),
    // license: () => import('@/views/fonts/License')
  },
  mixins: [observer, animation, gtag],
  data () {
    return {
      previewText: '',
      selectFontIndex: 0,
      isLicense: false,
      shareImagePath: `${process.env.VUE_APP_CDN_PATH}/static/image/font/m/visual_font.jpg`
    }
  },
  computed: {
    selectFont (val) {
      return val.list[val.selectFontIndex]
    },
    fontList (val) {
      const font = cloneDeep(val.list)
      return font.sort(function (a, b) {
        const c = new Date(val.$moment(a.date, 'YYYY, M'))
        const d = new Date(val.$moment(b.date, 'YYYY, M'))
        return d - c
      })
    },
    list () {
      return [
        {
          family: 'BM Kkubulim',
          name: this.$t('kkubulim.name'),
          nameKr: '배달의민족 꾸불림',
          shortName: this.$t('kkubulim.shortName'),
          date: this.$t('kkubulim.date'),
          description: this.$t('kkubulim.content'),
          download: {
            otf: require('@/static/font/BMkkubulim/BMKkubulim.otf'),
            ttf: require('@/static/font/BMkkubulim/BMKkubulimTTF.ttf')
          },
          images: [
            require('@/static/image/font/pc/kkubulim-1.png'),
            require('@/static/image/font/pc/kkubulim-2.gif'),
            require('@/static/image/font/pc/kkubulim-3.png'),
            require('@/static/image/font/pc/kkubulim-4.png'),
            require('@/static/image/font/pc/kkubulim-5.png'),
          ]
        },
        {
          // family: 'baeminGeullim',
          name: this.$t('baeminGeullim.name'),
          nameKr: '배달의민족 글림체',
          shortName: this.$t('baeminGeullim.shortName'),
          date: this.$t('baeminGeullim.date'),
          description: this.$t('baeminGeullim.content'),
          download: {
            png: 'https://woowahan-cdn.woowahan.com/static/fonts/BMGEULLIM.zip',
          },
          images: [
            require('@/static/image/font/pc/baemin-geullim-1.jpg'),
            require('@/static/image/font/pc/baemin-geullim-2.gif'),
            require('@/static/image/font/pc/baemin-geullim-3.jpg'),
            require('@/static/image/font/pc/baemin-geullim-4.jpg'),
          ],
          // link: {
          //  url: 'https://brandstore.baemin.com/baemin-geullim',
          //  text: this.$t('baeminGeullim.link')
          // },
          className: 'baemin-geullim'
        },
        {
          family: 'BM HANNA Pro',
          name: this.$t('hannaPro.name'),
          nameKr: '배민 한나체 Pro',
          shortName: this.$t('hannaPro.shortName'),
          date: this.$t('hannaPro.date'),
          description: this.$t('hannaPro.content'),
          download: {
            otf: require('@/static/font/BMHANNAPro/BMHANNAProOTF.otf'),
            ttf: require('@/static/font/BMHANNAPro/BMHANNAPro.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmhannapro.gif'),
          ]
        },
        {
          family: 'BM HANNA Air',
          name: this.$t('hannaAir.name'),
          nameKr: '배민 한나체 Air',
          shortName: this.$t('hannaAir.shortName'),
          date: this.$t('hannaAir.date'),
          description: this.$t('hannaAir.content'),
          download: {
            otf: require('@/static/font/BMHANNAAir/BMHANNAAir_otf.otf'),
            ttf: require('@/static/font/BMHANNAAir/BMHANNAAir_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmhannaair-1@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-2@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-3@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-4@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-5@3x.jpg'),
            require('@/static/image/font/pc/bmhannaair-6@3x.jpg'),
          ]
        },
        {
          family: 'BM HANNA 11yrs old',
          name: this.$t('hanna11YrsOld.name'),
          nameKr: '배민 한나는열한살체',
          shortName: this.$t('hanna11YrsOld.shortName'),
          date: this.$t('hanna11YrsOld.date'),
          description: this.$t('hanna11YrsOld.content'),
          download: {
            otf: require('@/static/font/BMHANNA_11yrs/BMHANNA_11yrs_otf.otf'),
            ttf: require('@/static/font/BMHANNA_11yrs/BMHANNA_11yrs_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmhanna11yrs-1@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-2@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-3@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-4@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-5@3x.jpg'),
            require('@/static/image/font/pc/bmhanna11yrs-6@3x.jpg'),
          ]
        },
        {
          family: 'BM Euljiro oraeorae',
          name: this.$t('euljiroOraeorae.name'),
          nameKr: '배민 을지로오래오래체',
          shortName: this.$t('euljiroOraeorae.shortName'),
          date: this.$t('euljiroOraeorae.date'),
          description: this.$t('euljiroOraeorae.content'),
          download: {
            otf: require('@/static/font/BMEuljirooraeorae/BMEuljirooraeoraeOTF.otf'),
            ttf: require('@/static/font/BMEuljirooraeorae/BMEuljirooraeorae.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmeuljirooraeorae-1.gif'),
            require('@/static/image/font/pc/bmeuljirooraeorae-2@3x.jpg'),
            require('@/static/image/font/pc/bmeuljirooraeorae-3@3x.jpg'),
            require('@/static/image/font/pc/bmeuljirooraeorae-4@3x.jpg'),
          ]
        },
        {
          family: 'BM Euljiro 10 years later',
          name: this.$t('euljiro10YearsLater.name'),
          nameKr: '배민 을지로10년후체',
          shortName: this.$t('euljiro10YearsLater.shortName'),
          date: this.$t('euljiro10YearsLater.date'),
          description: this.$t('euljiro10YearsLater.content'),
          download: {
            otf: require('@/static/font/BMEuljiro10yearslater/BMEuljiro10yearslaterOTF.otf'),
            ttf: require('@/static/font/BMEuljiro10yearslater/BMEuljiro10yearslater.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmeuljiro10yearslater-1@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro10yearslater-2@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro10yearslater-3@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro10yearslater-4@3x.jpg'),
          ]
        },
        {
          family: 'BM EULJIRO',
          name: this.$t('euljiro.name'),
          nameKr: '배민 을지로체',
          shortName: this.$t('euljiro.shortName'),
          date: this.$t('euljiro.date'),
          description: this.$t('euljiro.content'),
          download: {
            otf: require('@/static/font/BMEULJIRO/BMEULJIRO.otf'),
            ttf: require('@/static/font/BMEULJIRO/BMEULJIROTTF.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmeuljiro-1@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-2@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-3@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-4@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-5@3x.jpg'),
            require('@/static/image/font/pc/bmeuljiro-6@3x.jpg'),
          ]
        },
        {
          family: 'BM KIRANGHAERANG',
          name: this.$t('kiranghaerang.name'),
          nameKr: '배민 기랑해랑체',
          shortName: this.$t('kiranghaerang.shortName'),
          date: this.$t('kiranghaerang.date'),
          description: this.$t('kiranghaerang.content'),
          download: {
            otf: require('@/static/font/BMKIRANGHAERANG/BMKIRANGHAERANG-OTF.otf'),
            ttf: require('@/static/font/BMKIRANGHAERANG/BMKIRANGHAERANG-TTF.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmkiranghaerang-1@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-2@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-3@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-4@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-5@3x.jpg'),
            require('@/static/image/font/pc/bmkiranghaerang-6@3x.jpg'),
          ]
        },
        {
          family: 'BM YEONSUNG',
          name: this.$t('yeonsung.name'),
          nameKr: '배민 연성체',
          shortName: this.$t('yeonsung.shortName'),
          date: this.$t('yeonsung.date'),
          description: this.$t('yeonsung.content'),
          download: {
            otf: require('@/static/font/BMYEONSUNG/BMYEONSUNG_otf.otf'),
            ttf: require('@/static/font/BMYEONSUNG/BMYEONSUNG_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmyeonsung-1@3x.jpg'),
            require('@/static/image/font/pc/bmyeonsung-2@3x.jpg'),
            require('@/static/image/font/pc/bmyeonsung-3@3x.jpg'),
            require('@/static/image/font/pc/bmyeonsung-4@3x.jpg'),
            require('@/static/image/font/pc/bmyeonsung-5@3x.jpg'),
          ]
        },
        {
          family: 'BM DoHyeon',
          name: this.$t('dohyeon.name'),
          nameKr: '배민 도현체',
          shortName: this.$t('dohyeon.shortName'),
          date: this.$t('dohyeon.date'),
          description: this.$t('dohyeon.content'),
          download: {
            otf: require('@/static/font/BMDOHYEON/BMDOHYEON_otf.otf'),
            ttf: require('@/static/font/BMDOHYEON/BMDOHYEON_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmdohyeon-2@3x.jpg'),
            require('@/static/image/font/pc/bmdohyeon-3@3x.jpg'),
            require('@/static/image/font/pc/bmdohyeon-4@3x.jpg'),
            require('@/static/image/font/pc/bmdohyeon-5@3x.jpg'),
            require('@/static/image/font/pc/bmdohyeon-6@3x.jpg'),
          ]
        },
        {
          family: 'BM JUA',
          name: this.$t('jua.name'),
          nameKr: '배민 주아체',
          shortName: this.$t('jua.shortName'),
          date: this.$t('jua.date'),
          description: this.$t('jua.content'),
          download: {
            otf: require('@/static/font/BMJUA/BMJUA_otf.otf'),
            ttf: require('@/static/font/BMJUA/BMJUA_ttf.ttf')
          },
          images: [
            require('@/static/image/font/pc/bmjua-1@3x.jpg'),
            require('@/static/image/font/pc/bmjua-2@3x.jpg'),
            require('@/static/image/font/pc/bmjua-3@3x.jpg'),
            require('@/static/image/font/pc/bmjua-4@3x.jpg'),
            require('@/static/image/font/pc/bmjua-5@3x.jpg'),
          ]
        },
        {
          family: 'BM HANNA',
          name: this.$t('hanna.name'),
          nameKr: '배민 한나체',
          // shortName: this.$t('hanna.shortName'),
          date: this.$t('hanna.date'),
          description: this.$t('hanna.content'),
          // download: {
          //   otf: require('@/static/font/BMHANNA_11yrs/BMHANNA_11yrs_otf.otf'),
          //   ttf: require('@/static/font/BMHANNA_11yrs/BMHANNA_11yrs_ttf.ttf')
          // },
          images: [
            require('@/static/image/font/pc/bmhanna-1@3x.jpg'),
          ]
        }
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$refs.fonts.forEach((font) => {
        this.initGtag({
          element: font,
          ga: {
            action: 'click',
            name: '글꼴_개별 다운로드',
            category: '글꼴_개별 다운로드',
            label: font.dataset.ga,
            page: '글꼴'
          }
        })
      })

      this.initGtag({
        element: this.$refs.allDownload,
        ga: {
          action: 'click',
          name: '글꼴_전체 다운로드',
          category: '글꼴_전체 다운로드',
          label: '글꼴 전체 패키지 다운로드',
          page: '글꼴'
        }
      })
    },
    onPreviewText (e) {
      this.previewText = e.target.innerText
    },
    onToggleLicense () {
      this.isLicense = !this.isLicense
    },
    ga (event) {
      if (process.env.NODE_ENV === 'production') {
        this.$gtag.event(event.action, {
          event_category: event.category
        })
      }
    },
    onClickShare (e, type) {
      this.setGtag({
        action: 'click',
        name: '글꼴_공유하기',
        label: type,
        category: '글꼴_공유하기',
        page: '글꼴'
      })
    },
  }
}
</script>
